module.exports = __webpack_public_path__ + "img/company_2.eacf5d66.jpg";